import _taggedTemplateLiteral from '../../node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js';
import { DetailedIconCalculator, mediaMixin, Flex, Paragraph } from '@zillow/constellation';
import styled, { css } from 'styled-components';
import jsxRuntime from '../../node_modules/react/jsx-runtime.js';

var _templateObject, _templateObject2;
var StyledDetailedIconCalculator = styled(DetailedIconCalculator)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: none;\n    ", "\n"])), mediaMixin('lg', css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n            display: block;\n        "])))));
var Header = function Header() {
  return /*#__PURE__*/jsxRuntime.jsxs(Flex, {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    children: [/*#__PURE__*/jsxRuntime.jsx(StyledDetailedIconCalculator, {}), /*#__PURE__*/jsxRuntime.jsxs(Flex, {
      display: "flex",
      flexDirection: "column",
      marginLeft: "sm",
      children: [/*#__PURE__*/jsxRuntime.jsx(Paragraph, {
        fontType: "bodyHeading",
        children: "Calculate your budget"
      }), /*#__PURE__*/jsxRuntime.jsx(Paragraph, {
        children: "Deciding how much you can comfortably spend on a home will help you prepare for your search."
      })]
    })]
  });
};
var Header$1 = Header;

export { Header$1 as default };
//# sourceMappingURL=Header.js.map
